import http from "../http-common";

class DocumentoService {

    ingresar(data) {
        return http.post("/documento",data);
    }

    getAll() {
        return http.get("/documento");
    }

    delete(id) {
        return http.delete(`/documento/${id}`);
    }
}

export default new DocumentoService();